import {refreshParentSospeso} from "./sospeso";
import {flatpickrOptions, initFlatpickr} from "../flatpickrOptions";

function initChangeDocumentType() {
    const $element = $('form.journal_entry #journal_entry_document_type_id')
    const $counterpartSelect = $('form.journal_entry #journal_entry_counterpart_id')
    const $paymentMethodSelect = $('form.journal_entry #journal_entry_payment_method_id')
    const $documentLocationSelect = $('form.journal_entry #journal_entry_document_location_id')
    const $documentKindSelect = $('form.journal_entry #journal_entry_document_kind_id')
    const $suspendedSelect = $('form.journal_entry #journal_entry_parent_id')
    const $dataDocument = $('form.journal_entry #journal_entry_data_documento')
    const $udpSelect = $("form.journal_entry #journal_entry_udp_id");
    $element.on('change', function (e) {
        const optionSelected = $("option:selected", this);
        const identifier = (optionSelected.data('identifier'))
        $.getJSON(`/admin/journal_entries/counterparts?document_type_id=${this.value}`, function (data) {
            const autoSelect = data.length === 1
            const alreadySelected = parseInt($counterpartSelect.find('option:selected')?.val());
            $counterpartSelect.find('option').remove()
            const newOption = new Option(" ", '', false, false);
            !autoSelect && $counterpartSelect.append(newOption);
            $.each(data, function (i, d) {
                const newOption = new Option(d[0], d[1], false, autoSelect || (alreadySelected === d[1]));
                d[2] && newOption.setAttribute("data-identifier", d[2]['data-identifier'])
                $counterpartSelect.append(newOption);
            })
            $counterpartSelect.trigger('change');
        });

        // $.getJSON(`/admin/journal_entries/payment_methods?document_type_id=${this.value}`, function (data) {
        //     const autoSelect = data.length === 1
        //     const alreadySelected = parseInt($paymentMethodSelect.find('option:selected')?.val());
        //     $paymentMethodSelect.find('option').remove()
        //     const newOption = new Option(" ", '', false, false);
        //     !autoSelect && $paymentMethodSelect.append(newOption);
        //     $.each(data, function (i, d) {
        //         const newOption = new Option(d[0], d[1], false, autoSelect || (alreadySelected === d[1]));
        //         d[2] && newOption.setAttribute("data-identifier", d[2]['data-identifier'])
        //         $paymentMethodSelect.append(newOption);
        //     })
        //     $paymentMethodSelect.trigger('change');
        // });


        $.getJSON(`/admin/journal_entries/document_locations?document_type_id=${this.value}&udp_id=${$udpSelect.val()}`, function (data) {
            const autoSelect = data.length === 1
            const alreadySelected = parseInt($documentLocationSelect.find('option:selected')?.val());
            $documentLocationSelect.find('option').remove()
            const newOption = new Option(" ", '', false, false);
            !autoSelect && $documentLocationSelect.append(newOption);
            $.each(data, function (i, d) {
                const newOption = new Option(d[0], d[1], false, autoSelect || (alreadySelected === d[1]));
                d[2] && newOption.setAttribute("data-identifier", d[2]['data-identifier'])
                $documentLocationSelect.append(newOption);
            })
            $documentLocationSelect.trigger('change');
        });

        refreshParentSospeso(this.value)

        $.getJSON(`/admin/journal_entries/document_kinds?document_type_id=${this.value}`, function (data) {
            const autoSelect = data.length === 1
            const alreadySelected = parseInt($documentKindSelect.find('option:selected')?.val());
            $documentKindSelect.find('option').remove()
            const newOption = new Option(" ", '', false, false);
            !autoSelect && $documentKindSelect.append(newOption);
            $.each(data, function (i, d) {
                const newOption = new Option(d[0], d[1], false, autoSelect || (alreadySelected === d[1]));
                d[2] && newOption.setAttribute("data-identifier", d[2]['data-identifier'])
                $documentKindSelect.append(newOption);
            })
            $documentKindSelect.trigger('change');
        });

        const $dateParent = $dataDocument.closest('.date_picker');
        let $b = $dateParent.find('#journal_entry_data_documento');
        let fp = $b?.get(0)._flatpickr
        if (fp === undefined) {
            // ancora non inizializzato in alcuni casi
            initFlatpickr()
            fp = $b?.get(0)._flatpickr
        }
        if (identifier === 'saldo_iniziale') {
            fp && fp.clear()
            fp && fp._input && fp._input.setAttribute("disabled", "disabled");

        } else {
            fp && fp._input && fp._input.removeAttribute("disabled");
        }

        // }
    })
}

export { initChangeDocumentType }